import type { RELATIONSHIP_TYPES, RelationshipStateT } from '../../../../common/types/types';
export const RELATIONSHIP_ACTIONS = ({
  SET_PRIMARY_ANNOTATION: 'SET_RELATIONSHIP_PRIMARY_ANNOTATION',
  SET_RELATIONSHIP_TYPE: 'SET_RELATIONSHIP_TYPE',
  SET_CHILDREN: 'SET_CHILDREN',
  SET_PARENT: 'SET_PARENT',
  CREATE_RELATIONSHIP: 'CREATE_RELATIONSHIP',
  CANCEL_RELATIONSHIP: 'CANCEL_RELATIONSHIP',
  UNLINK_RELATIONSHIP: 'UNLINK_RELATIONSHIP'
} as const);
export function setPrimaryAnnotationAction(annotationId: string | undefined) {
  return {
    type: RELATIONSHIP_ACTIONS.SET_PRIMARY_ANNOTATION,
    annotationId
  };
}
export function setRelationshipTypeAction(relationshipType: typeof RELATIONSHIP_TYPES.childToParent | typeof RELATIONSHIP_TYPES.parentToChild) {
  return {
    type: RELATIONSHIP_ACTIONS.SET_RELATIONSHIP_TYPE,
    relationshipType
  };
}
export function setChildrenAction(childrenIds: Array<string>) {
  return {
    type: RELATIONSHIP_ACTIONS.SET_CHILDREN,
    childrenIds
  };
}
export function setParentAction(parentId: string) {
  return {
    type: RELATIONSHIP_ACTIONS.SET_PARENT,
    parentId
  };
}
export function createRelationshipAction() {
  return {
    type: RELATIONSHIP_ACTIONS.CREATE_RELATIONSHIP
  };
}
export function cancelRelationshipAction() {
  return {
    type: RELATIONSHIP_ACTIONS.CANCEL_RELATIONSHIP
  };
}
export function unlinkRelationshipAction(parentId: string, childId: string) {
  return {
    type: RELATIONSHIP_ACTIONS.UNLINK_RELATIONSHIP,
    parentId,
    childId
  };
}
export type CreateRelationshipActionT = {
  type: typeof RELATIONSHIP_ACTIONS.CREATE_RELATIONSHIP;
  relationshipMode?: RelationshipStateT;
};
export type UnlinkRelationshipActionT = {
  type: typeof RELATIONSHIP_ACTIONS.UNLINK_RELATIONSHIP;
  parentId: string;
  childId: string;
};
export type RelationshipActionsT = {
  type: typeof RELATIONSHIP_ACTIONS.SET_PRIMARY_ANNOTATION;
  annotationId: string | undefined;
} | {
  type: typeof RELATIONSHIP_ACTIONS.SET_RELATIONSHIP_TYPE;
  relationshipType: typeof RELATIONSHIP_TYPES.childToParent | typeof RELATIONSHIP_TYPES.parentToChild;
} | {
  type: typeof RELATIONSHIP_ACTIONS.SET_CHILDREN;
  childrenIds: Array<string>;
} | {
  type: typeof RELATIONSHIP_ACTIONS.SET_PARENT;
  parentId: string;
} | {
  type: typeof RELATIONSHIP_ACTIONS.CANCEL_RELATIONSHIP;
} | {
  type: typeof RELATIONSHIP_ACTIONS.UNLINK_RELATIONSHIP;
  parentId: string;
  childId: string;
} | CreateRelationshipActionT;